/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import TextareaAutosize from '@mui/material/TextareaAutosize';

import { Field, getIn } from 'formik';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    margin: theme.spacing(1),
  },
}));

export const RenderTextArea = ({ field, form: { touched, errors }, inputProps, ...others }) => {
  const touch = getIn(touched, field.name);
  const error = getIn(errors, field.name);

  return (
    <FormControl variant="standard" error={touch && error != null} {...others}>
      <TextareaAutosize
        name={field.name}
        value={field.value}
        onChange={field.onChange}
        onBlur={field.onBlur}
        {...inputProps}
      />
      {touch && error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export const FormTextArea = ({ name, rows, rowsMax, placeholder, style, ...others }) => {
  const { classes } = useStyles();
  return (
    <Field
      name={name}
      component={RenderTextArea}
      className={classes.formControl}
      inputProps={{ rows, rowsMax, placeholder, style }}
      {...others}
    />
  );
};
